/**
 * @fileoverview Progressive US phone-number formatter for controlled inputs.
 *
 * Mirrors mobile's `src/lib/phone.js` so both clients format phone entry the
 * same way. Re-derives the display string from the digits entered so far, so it
 * works whether typing forward or backspacing: every keystroke we strip
 * everything but digits, cap at 10, and lay them back into the `(555) 555-5555`
 * shape. Partial input formats partially — `5551` becomes `(555) 1` — so the
 * field grows toward the placeholder as you type.
 *
 * Storing the formatted value is fine for the backend: consent SMS delivery
 * normalizes to E.164 (`normalize_phone`) and ignores the punctuation.
 *
 * @param {string|null|undefined} value Raw input value (may already be partly formatted)
 * @returns {string} The reformatted value, or '' when there are no digits
 */
export function formatPhoneInput(value) {
  const digits = String(value ?? '').replace(/\D/g, '').slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length < 4) return `(${digits}`;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
